import React from "react";
import { DatasetStringValueMapperDTO } from "../../../charts/interfaces";

const MapperMappings = ({
  selectedMapper,
}: {
  selectedMapper: DatasetStringValueMapperDTO;
}) => {
  return (
    <div>
      {Object.keys(selectedMapper.mappings).length === 0 ? (
        <h3>No mappings</h3>
      ) : (
        <ul>
          {Object.entries(selectedMapper.mappings).map(([key, value]) => (
            <li key={key}>
              {key}: {value}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MapperMappings;
